import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Meta (Facebook) Pixel loader — Pixel ID 2566836647063486.
 * Fires only when `consent === true` (marketing/analytics cookies accepted).
 * Appends the exact recommended base pixel snippet plus the <noscript> fallback
 * to document.head. Also fires a PageView on every SPA route change so
 * client-side navigations are attributed correctly.
 * Do NOT alter the pixel code or Pixel ID.
 */
export const MetaPixel = ({ consent }) => {
  const location = useLocation();

  // Base pixel install — runs once when consent is granted.
  useEffect(() => {
    if (!consent) return;
    if (window.__vemoye_fb_loaded) return;
    window.__vemoye_fb_loaded = true;

    // Base script (Meta's exact recommended snippet)
    const base = document.createElement("script");
    base.dataset.vemoyeFb = "base";
    base.text = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '2566836647063486');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(base);

    // noscript pixel fallback
    const ns = document.createElement("noscript");
    ns.dataset.vemoyeFb = "noscript";
    ns.innerHTML = `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=2566836647063486&ev=PageView&noscript=1" />`;
    document.head.appendChild(ns);
  }, [consent]);

  // SPA route-change PageView — dedupe by pathname so remounts and
  // StrictMode double-invocations do not fire duplicate conversions.
  useEffect(() => {
    if (!consent) return;
    if (typeof window.fbq !== "function") return;
    if (!window.__vemoye_fb_first_view_sent) {
      window.__vemoye_fb_first_view_sent = true;
      window.__vemoye_fb_last_view_path = location.pathname;
      return;
    }
    if (window.__vemoye_fb_last_view_path === location.pathname) return;
    window.__vemoye_fb_last_view_path = location.pathname;
    try { window.fbq("track", "PageView"); } catch {}
  }, [location.pathname, consent]);

  return null;
};

export default MetaPixel;
